<ng-container *ngIf="data">
    <h3 class="subscribe__title">{{ data.title }}</h3>
    <p class="subscribe__description">{{ data.description }}</p>

    <form #subscribeForm="ngForm" [ngClass]="{busy: isBusy}" class="subscribe__form">
        <div class="input-group">
            <label for="email">{{ data.inputLabel }}</label>
            <input tabindex="0"
                class="subscribe__input--email"
                id="email"
                name="email"
                [pattern]="emailPattern"
                required
                [(ngModel)]="email"
                (click)="isSuccess = undefined; isSubscribed = false"
                #emailInput
                [placeholder]="'mailchimpPanel.WatermarkText' | translate" required type="email">
        </div>
    </form>

    <div class="subscribe__agreements-wrapper">
        <ubl-checkbox class="subscribe__agreements agreements" [noChanges]="agreedControlNoChanges" [(ngModel)]="agreed">
            {{ 'mailchimpPanel.AgreementText' | translate }}
            <a *ngIf="data?.cookiePolicyPageUrl" class="subscribe__policy--link" [routerLink]="data.cookiePolicyPageUrl" (click)="$event && $event.stopPropagation()">{{data?.cookiePolicyTitle}}</a>
        </ubl-checkbox>
        <div class="subscribe__policy" (click)="showPrivacy.emit()">{{ 'mailchimpPanel.PrivacyPolicyLabel' | translate}}</div>
    </div>
    <br/>
    <re-captcha (resolved)="reCaptchaValidated($event)" #captcha="reCaptcha" siteKey="{{data.reCaptchaSecret}}"></re-captcha>

    <button ubl-button
        class="submit"
        (click)="onSubscribe(email)"
        [disabled]="!agreed || !subscribeForm.form.valid || isSuccess === false || !captchaResponse">
        {{ 'mailchimpPanel.ButtonText' | translate }}
        <i class="icon icon-arrow-right after" *ngIf="isSuccess === undefined"></i>
        <i class="icon after" *ngIf="isSuccess !== undefined"  [ngClass]="isSuccess ? 'icon-checked' : 'icon-cross'"></i>
    </button>

    <div class="success-message" *ngIf="isSubscribed">
        {{'subscribePanel.SuccessMessage' | translate}}
    </div>
</ng-container>
